<template>
  <div id="center">
	<span class="fs-xl text mx-2 pl-3" style="margin-top: 5px; margin-left: 10px; margin-top: 10px; padding-bottom: 0;">
		<icon name="align-left" class="text-icon" style="margin-right: 5px; float: left;"></icon>
		筛查入群人数
	</span>
    <div class="down">
      <div class="ranking bg-color-black">
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking" />
      </div>
    </div>
  </div>
</template>

<script>
// import CenterChart from '@/components/echart/center/centerChartRate'

export default {
  data() {
    return {
      ranking: {
        data: [
          {
            name: '兴安街道',
            value: 7728
          },
          {
            name: '新安街道',
            value: 5753
          },
          {
            name: '凌河街道',
            value: 5439
          },
          {
            name: '景芝镇',
            value: 456
          },
		  {
		    name: '官庄镇',
		    value: 3058
		  },
		  {
		    name: '大盛镇',
		    value: 539
		  },
		  {
		    name: '石埠子镇',
		    value: 842
		  },
		  {
		    name: '石堆镇',
		    value: 3187
		  },
		  {
		    name: '拓山镇',
		    value: 2754
		  },
		  {
		    name: '辉渠镇',
		    value: 352
		  },
		  {
		    name: '吾山镇',
		    value: 654
		  },
		  {
		    name: '金冢子镇',
		    value: 2135
		  }
        ],
        carousel: 'single',
        unit: '人'
      },
      water: {
        data: [24, 45],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 3
      },
      // 通过率和达标率的组件复用数据
      rate: [
        {
          id: 'centerRate1',
          tips: 60,
          colorData: {
            textStyle: '#3fc0fb',
            series: {
              color: ['#00bcd44a', 'transparent'],
              dataColor: {
                normal: '#03a9f4',
                shadowColor: '#97e2f5'
              }
            }
          }
        },
        {
          id: 'centerRate2',
          tips: 40,
          colorData: {
            textStyle: '#67e0e3',
            series: {
              color: ['#faf3a378', 'transparent'],
              dataColor: {
                normal: '#ff9800',
                shadowColor: '#fcebad'
              }
            }
          }
        }
      ]
    }
  },
  components: {
    // CenterChart
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 25%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: auto;
	overflow: hidden;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 100%;
      .dv-scr-rank-board {
        height: 340px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
